<template>
  <h1
    v-if="size === 'large'"
    class="heading"
    :class="{ 'heading--large': size === 'large' }"
    v-html="text"></h1>
  <h2
    v-else-if="size === 'medium'"
    class="heading"
    :class="{ 'heading--medium': size === 'medium' }"
    v-html="text"></h2>
  <h3
    v-else
    class="heading"
    :class="{ 'heading--small': size === 'small' }"
    v-html="text"></h3>
</template>

<script>
export default {
  name: 'Heading',
  props: {
    text: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'medium'
    }
  }
}
</script>

<style lang="scss" scoped>
.heading {

  @media screen and (max-width: $mobile) {


  }
}
</style>
